import { createConnectTransport } from "@connectrpc/connect-web";
import { Interceptor, Code } from "@connectrpc/connect";
import { handleSessionExpired } from "@shared/utils/authSession";

/**
 * Источник токена для ConnectRPC — ровно тот же, что у axios-клиента:
 * сырые ключи localStorage плюс dev-токен.
 *
 * Здесь СОЗНАТЕЛЬНО нет двух прежних фолбэков: чтения `accessToken` из
 * persist-блоба `workernet-auth-store` и перебора «любого ключа, который
 * оканчивается на access_token». Оба воскрешали токен, переживший выход:
 * отсутствие токена должно быть отсутствием токена, а не поводом поискать
 * его где-нибудь ещё.
 */
export const resolveConnectAuthToken = (): string | null => {
  const token =
    localStorage.getItem('workernet_access_token') ||
    localStorage.getItem('access_token') ||
    localStorage.getItem('token');

  if (token) return token;

  if (import.meta.env.DEV) {
    return import.meta.env.VITE_DEV_AUTH_TOKEN || 'dev-local-token';
  }

  return null;
};

// Интерцептор для добавления токена авторизации
const authInterceptor: Interceptor = (next) => async (req) => {
  const token = resolveConnectAuthToken();

  if (token) {
    req.header.set("Authorization", `Bearer ${token}`);
  }

  try {
    return await next(req);
  } catch (err: any) {
    // Глобальная обработка ошибки аутентификации для всех ConnectRPC запросов
    if (err.code === Code.Unauthenticated) {
      console.error("[ConnectClient] Unauthenticated error detected, triggering session expiry", { url: req.url });
      handleSessionExpired('expired', {
        showNotification: true,
        redirectToLogin: true,
      });
    }
    throw err;
  }
};

// Создаем транспорт для ConnectRPC
// В разработке используем относительный путь или полный URL бэкенда
export const transport = createConnectTransport({
  baseUrl: "/api/v1", // Базовый путь API, где смонтированы Connect-хендлеры
  interceptors: [authInterceptor],
});
